<script setup>
import { onMounted, ref } from 'vue'
import { get_user_roles, get_user, update_user } from '@/services/user'
import { get_roles } from '@/services/roles'
import { useRoute } from 'vue-router';
import childList from './component/childList.vue'
import actionList from './component/actionList.vue'
import rewardHistory from './component/rewardHistory.vue'
import { swalError, swalSuccess } from '@/helper';

const user = ref({
  attributes:{
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    role_id: null
  }
})

const route = useRoute()
const isLoading = ref(true)
onMounted(async ()=>{
  await retrieve_role()
  let response = await get_user(route.params.id)
  user.value = response.data.data
  isLoading.value = false
})
const hasChange = ref(false)

async function updateUser(){
  let userObj = {...user.value}
  if (user.value.password == ''){
    delete userObj.attributes['password']
  }
  let response = await update_user(userObj, user.value.attributes.id )
  if (response.error){
    swalError(response.data, true)
  }else{
    swalSuccess('User updated')
  }
}

const roles = ref([])
async function retrieve_role(){
  let response = await get_roles()
  if (response.error){
    swalError(response.data, true)
    return
  }
  roles.value = response.data.data.map(role => {
    return {
      valueProp: role.id,
      label: role.attributes?.name
    }
  })
}
</script>

<template>
  <div class="col-12 pt-4">
    <LoadingCard v-if="isLoading" />
    <form v-else @submit.prevent="updateUser()" class="card">
      <div class="card-header ">
        <h4 class="card-title mb-0">Edit Profile</h4>
        <div class="card-options">
          <a class="card-options-collapse" href="javascript:void(0)"
          data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove"
            href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">First Name</label>
              <input v-model="user.attributes.first_name" class="form-control" type="text" placeholder="First name">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Last Name</label>
              <input v-model="user.attributes.last_name" class="form-control" type="text" placeholder="Last Name">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Email address</label>
              <input disabled v-model="user.attributes.email" class="form-control" type="email" placeholder="Email">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Set New Password</label>
              <input v-model="user.attributes.password" class="form-control" type="password" placeholder="password">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Role</label>
              <multiselect 
                v-model="user.attributes.role_id" 
                placeholder="Change role"
                :options="roles"
                valueProp="valueProp"
                label="label"
                track-by="id"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer text-end">
        <button class="btn btn-primary" type="submit">Update Profile</button>
      </div>
    </form>
  </div>

  <template v-if="user.id != undefined">
    <childList  :user_id="user.id"/>
    <!-- <actionList :user="user"/> -->
    <rewardHistory :user_id="user.id"/>
  </template>
  <LoadingCard v-else/>
</template>